import { Facebook, Linkedin, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="font-serif text-2xl font-bold mb-4">Forty Chambers</h3>
            <p className="font-sans text-sm leading-relaxed text-primary-foreground/70">
              Professional legal services in Ontario. Clarity, Experience, Confidence.
            </p>
          </div>

          <div>
            <h4 className="font-sans text-sm font-semibold tracking-wide uppercase mb-4">Quick Links</h4>
            <div className="space-y-2">
              <Link to="/expertise" className="block text-sm hover:text-accent transition-colors">
                Our Services
              </Link>
              <Link to="/about" className="block text-sm hover:text-accent transition-colors">
                About Us
              </Link>
              <Link to="/events" className="block text-sm hover:text-accent transition-colors">
                Events
              </Link>
              <Link to="/contact" className="block text-sm hover:text-accent transition-colors">
                Contact
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-sans text-sm font-semibold tracking-wide uppercase mb-4">Follow Us</h4>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-accent transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-accent transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-accent transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-border/20 mt-8 pt-8 text-center">
          <p className="text-sm text-primary-foreground/70">
            © {new Date().getFullYear()} Forty Chambers. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;